import { ReactNode } from 'react';
import BordOneToneIcon from '../NudosComponents/BordOneToneIcon/BordOneToneIcon';
import NudosHoverText from '../NudosComponents/NudosHoverText/NudosHoverText';

import './LastUpdate.scss';

export interface ILastEventInfo {
  title: string;
  description: string;
  date: string;
  isProblemActive: boolean;
}

interface ILastUpdateProps {
  children?: ReactNode;
  lastEvent?: ILastEventInfo;
}

const LastUpdate = ({ children, lastEvent }: ILastUpdateProps) => {
  return (
    <div className="lastUpdate">
      <div className="statusContainer">{children}</div>

      {lastEvent && (
        <div className="lastEventSection">
          <p className="lastEventTitle">Última actualización</p>

          <div className="lastEventCard">
            {lastEvent.isProblemActive && (
              <BordOneToneIcon variant="alertTriangleWarning" stroke="#FF0000" standardSize={14} />
            )}

            <div className="lastEventCardContent">
              <div className="lastEventHeader">
                <NudosHoverText
                  customClassName={`lastEventTitle ${lastEvent.isProblemActive ? 'problemActive' : ''}`}
                  text={lastEvent.title}
                  charactersLimit={lastEvent.isProblemActive ? 20 : 25}
                  onlyIfTruncated
                />
                <span className="lastEventDate">{lastEvent.date}</span>
              </div>

              <NudosHoverText
                customClassName="lastEventDescription"
                text={lastEvent.description}
                charactersLimit={lastEvent.isProblemActive ? 53 : 58}
                onlyIfTruncated
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LastUpdate;
